import React from 'react';
import img_LoadingSpinner from 'static/images/loader.gif';
import { Container } from 'components/Common/LoadingSpinnerStyles';
export default () => (
	<Container>
		<img src={img_LoadingSpinner} alt='LoadingSpinner' />
	</Container>
);
